import React from "react";

import {
  formatMoney,
  formatPercent,
  formatRatio,
} from "../../../utils/formatters";

export default function RiskFinancingKpis({
  summary,
  settings,
}) {
  const currency = settings?.currency || "USD";

  const mitigationValue =
    summary?.mitigation_investment ??
    summary?.control_investment ??
    null;

  const mitigationSubtitle =
    mitigationValue === null
      ? "Not yet integrated"
      : summary?.mitigation_label || "Controls applied";

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-6 gap-4">
      <KpiCard
        title="Expected Annual Loss"
        value={formatMoney(
          summary?.total_eal,
          currency
        )}
      />

      <KpiCard
        title="Mitigation Controls"
        value={
          mitigationValue === null
            ? "—"
            : formatMoney(
                mitigationValue,
                currency
              )
        }
        subtitle={mitigationSubtitle}
      />

      <KpiCard
        title="Insurance Transfer"
        value={formatMoney(
          summary?.transferred_eal,
          currency
        )}
        subtitle={`${formatPercent(
          normalizePercentage(summary?.transferred_pct)
        )} of EAL`}
      />

      <KpiCard
        title="Company Retained Risk"
        value={formatMoney(
          summary?.retained_eal,
          currency
        )}
        subtitle={`${formatPercent(
          normalizePercentage(summary?.retained_pct)
        )} of EAL`}
      />

      <KpiCard
        title="Residual Risk Exposure"
        value={formatMoney(
          summary?.residual_eal,
          currency
        )}
        subtitle="Above policy limit"
      />

      <KpiCard
        title="Insurance Efficiency"
        value={formatRatio(
          summary?.transfer_efficiency
        )}
        subtitle="Expected recovery / premium"
      />
    </div>
  );
}

function KpiCard({
  title,
  value,
  subtitle,
}) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 p-4">
      <p className="text-xs font-medium text-slate-500">
        {title}
      </p>

      <p className="text-xl font-semibold text-slate-900 mt-2">
        {value}
      </p>

      {subtitle && (
        <p className="text-xs text-slate-500 mt-1">
          {subtitle}
        </p>
      )}
    </div>
  );
}

function normalizePercentage(value) {
  const number = Number(value || 0);

  return number > 1
    ? number / 100
    : number;
}